export default __webpack_public_path__ + "assets/images/904b10772d68e754e21545cfe4c79cb3.png";